import {
    IconButton,
    IStackStyles,
    Modal,
    PrimaryButton,
    Stack
} from "@fluentui/react";
import React, { FunctionComponent, useCallback, useEffect, useState } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
//import GoBackToMainDialogBtn from "../addInventoryDialog/GoBackToMainDialogBtn";
import {
    cancelIcon,
    contentStyles as content,
    iconButtonStyles,
} from "constants/styles";
import { Calendar } from "primereact/calendar";
import { Col, Row } from "react-grid-system";
import { useDispatch } from "react-redux";
import { handleCreateOneDaySaleDate, handleUpdateOneDaySaleDate } from "store/oneDaySale/oneDaySale.action";
import { convertLocalToUTCModified, convertUTCToLocalDateOnlyModified, convertUTCToLocalModified } from "utils/dateTimeFunctions";
import moment from "moment";


const contentStyles = content(600, "auto");

interface IProps {
    title: string;
    onDismiss: () => void;
    formData: any;
}

export const AddEditOneDaySaleDialog: FunctionComponent<IProps> = ({
    title,
    onDismiss,
    formData
}) => {

    const [saleDate, setSaleDate] = useState<Date| any>(null);
    const [date, setDate] = useState<Date| any>(null);
    const [commonServerError, setcommonServerError] = React.useState(null);
    const yearRange = "1980:" + (new Date().getFullYear() + 1);

    const dispatch = useDispatch();

    useEffect(() => {
        if (formData) {
            setDate(formData?.saleDate ? new Date(convertUTCToLocalDateOnlyModified(formData?.saleDate)) : null);
            setSaleDate(formData?.saleDate ? new Date(convertUTCToLocalModified(formData?.saleDate)) : null);
        }
    }, [formData]);// eslint-disable-line react-hooks/exhaustive-deps

    const handleAddList = useCallback(() => {
        if (!formData) {
            dispatch<any>(
                handleCreateOneDaySaleDate(
                    {
                        saleDate: { saleDate: saleDate ? convertLocalToUTCModified(saleDate) : '' },
                        callback: (data, error) => {
                            if (data) {
                                setcommonServerError('');
                                onDismiss();
                            } else {
                                setcommonServerError('Sale date is already registered');
                            }
                        }
                    })
            );
        } else {
            dispatch<any>(
                handleUpdateOneDaySaleDate(
                    {
                        id: formData?.id,
                        saleDate: { saleDate: saleDate ? convertLocalToUTCModified(saleDate) : '' },
                        callback: (res, error) => {
                            if (res) {
                                setcommonServerError('');
                                onDismiss();
                            } else {
                                setcommonServerError('Sale date is already registered');
                            }
                        }
                    })
            );
        }
    }, [formData, saleDate])// eslint-disable-line react-hooks/exhaustive-deps

    const handleDateChange = (val) => {
        setDate(val);
        setSaleDate((val ? (moment(val).format("YYYY-MM-DD")) : null));
    };

    return (
        <Modal
            isOpen={true}
            onDismiss={onDismiss}
            isBlocking={true}
            containerClassName={contentStyles.container}
        >
            <div className={contentStyles.header + " inventory-popup modal-header"} style={{ width: "auto" }}>
                <span className="formTitle">{formData?.id && formData?.id > 0 ? "Edit " : "Add "}{title}</span>
                <IconButton
                    styles={iconButtonStyles}
                    iconProps={cancelIcon}
                    ariaLabel="Close popup modal"
                    onClick={onDismiss}
                />
            </div>
            {
                commonServerError ?
                    <div style={{ marginLeft: '30px' }}>

                        <p className="genericErrorColor"><span>{commonServerError}</span></p>

                    </div> : null
            }
            <div style={{ height: '180px' }} className={contentStyles.body + " expenseDialogPopup inv-srch-bdy body-auto-hight list-dialog-body"} >
                <Stack
                    styles={stackStyles}
                    verticalAlign="start"
                    horizontalAlign="space-between"
                >
                    <Row className="saleDateModal inventoryRowSection" justify="center">
                        <Col sm={7} md={7} xs={7}>
                            <div className="ms-TextField saleDateModal">
                                <div className="saleDateModal ms-TextField-wrapper">
                                    <label className="saleDateModal lbl-text required-Label">Sale Date</label>
                                    <div className="saleDateModal ms-TextField-fieldGroup mask-FieldGroup p-datepicker-right">
                                        <Calendar
                                            id="navigatorstemplate"
                                            value={date}
                                            style={{ width: "100%" }}
                                            className="saleDateModal"
                                            showIcon
                                            onChange={(e) => handleDateChange(e.value)}
                                            monthNavigator
                                            required={true}
                                            appendTo="self"
                                            yearRange={yearRange}
                                            yearNavigator />
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row className="inventoryRowSection footerBtn">
                        <Col style={{ textAlign: "center",marginTop:'15px' }}>
                            <PrimaryButton
                                text="Save"
                                disabled={!saleDate}
                                onClick={handleAddList}
                            />
                        </Col>
                    </Row>
                </Stack>
            </div>
        </Modal>
    );
};


const stackStyles: IStackStyles = {
    root: {},
};
